module.exports = __webpack_public_path__ + "media/images/glasses-5a215925dd1e4a8a34208ccfb082df90.jpg";